import React from 'react';
import PropTypes from 'prop-types';
import SdkPicker1 from '../svg/SdkPicker1';
import SdkPicker2 from '../svg/SdkPicker2';
import SdkPicker3 from '../svg/SdkPicker3';

class Step3 extends React.Component {
  constructor() {
    super();
    this.stop = false;
  }
  state = {
    picker2: false,
    picker3: false,
    picker1: true
  };

  componentDidMount() {
    this.startAnimation();
  }

  componentWillUnmount() {
    clearTimeout(this.loadInterval);
    this.loadInterval = false;
    this.stop = true;
  }

  setStatePromise = (newState, delay) =>
    new Promise(resolve => {
      this.loadInterval = setTimeout(() => {
        if (this.stop) return resolve();
        return this.setState(newState, () => resolve());
      }, delay);
    });

  startAnimation = () => {
    this.setStatePromise({ picker1: false, picker2: true }, 2000).then(() =>
      this.setStatePromise({ picker2: false, picker3: true }, 2000).then(() => {
        this.props.setStep(4, 2000);
      })
    );
  };

  render() {
    return (
      <div>
        {this.state.picker2 && <SdkPicker2 visibility={this.state.picker2} />}
        {this.state.picker3 && <SdkPicker3 visibility={this.state.picker3} />}
        {this.state.picker1 && <SdkPicker1 visibility={this.state.picker1} />}
      </div>
    );
  }
}

Step3.propTypes = {
  setStep: PropTypes.func.isRequired
};

export default Step3;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/components/Step3.js